{
  "version": "0.2.0",
  "gitCommitHash": "9e21ca2df861019b51c3c6afd7a4ff72f1aaefb5",
  "gitCommitShortHash": "9e21ca2",
  "gitBranch": "HEAD",
  "gitTags": "",
  "clean": true
}